import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Shield, Webhook, GitMerge, Clock, Lock, Users } from "lucide-react";
import * as tests from "./testDefinitions";

export const SecurityHardeningSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Security & Hardening</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Users}
          iconColor="text-blue-600"
          title="RBAC Matrix (Role-Based Access)"
          tests={tests.rbacMatrixTests}
          results={testResults.rbacMatrix}
        />
        
        <TestSubsection
          icon={Webhook}
          iconColor="text-orange-600"
          title="Webhook Security"
          tests={tests.webhookSecurityTests}
          results={testResults.webhookSecurity}
        />
        
        <TestSubsection
          icon={GitMerge}
          iconColor="text-green-600"
          title="Booking Mutations"
          tests={tests.bookingMutationsTests}
          results={testResults.bookingMutations}
        />
        
        <TestSubsection
          icon={Clock}
          iconColor="text-yellow-600"
          title="Concurrency & Race Conditions"
          tests={tests.concurrencyTests}
          results={testResults.concurrency}
        />
        
        <TestSubsection
          icon={Lock}
          iconColor="text-red-600"
          title="PII & Data Security"
          tests={tests.piiSecurityTests}
          results={testResults.piiSecurity}
        />
        
        <TestSubsection
          icon={Shield}
          iconColor="text-purple-600"
          title="Tenant Isolation Deep Tests"
          tests={tests.tenantIsolationTests}
          results={testResults.tenantIsolation}
        />
      </CardContent>
    </Card>
  );
};
